import { useEffect } from 'react';
import Navbar from './Navbar';
import { useLocation, useNavigate } from 'react-router-dom';

function YtCommentFilterHome() {

  const isShowConsole = process.env.NODE_ENV === 'development';

  const location = useLocation();
  const navigate = useNavigate();

  const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

  useEffect(() => {
    document.title = "YouTube Comment Filter - Highlight Only Positive Comments";
  }, []);

  const redirectToExtension = e => {
    try {
      const a = document.createElement('a');
      a.href = "https://chromewebstore.google.com/detail/youtube-comment-filter/nennmjoogjjonjpkgellegdmjbpkajgk";
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.click();
    } catch (err) {
      isShowConsole && console.log('error in redirectToExtension: ', err);
    }
  };


  return (
    <div className='parentDiv'>
      {<>
        <div className='mainDiv newUser ytExtension'>
        <div className="heroSection">
          <Navbar isNewUser={true}/>     
          <div className='intro'>
            <div className='introWrapper'>
              <div className='headline'>Tired of Reading Hate Comments?<br/> Filter Positive Comments Instantly!</div>
              <div className='sub-headline'>
                Eliminate negativity from your comment section. See only love, support and constructive feedback!
              </div>
              <div className='ctaContainer'>
                <div className='wrapper'>
                    <div className='extensionLink' onClick={redirectToExtension}>
                      <img src='/chrome-webstore-badge-medium.png' alt='chrome webstore icon'/>
                    </div>
                  <div className='infoTxt'><span>Enjoy a peaceful, productive YouTube experience, always!</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='ytFilterDemoContainer'>
        <div className='wrapper'>
            <video
              src="/yt-comment-filter-demo.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="demoVideo"
            />
        </div>
      </div>
      </>
      }
    </div>
  );
}

export default YtCommentFilterHome;
